import BvBtn from 'volta/components/bv-btn';
import BvStack from 'volta/components/bv-stack';
import BvText from 'volta/components/bv-text';

import type { BvBtnArgs } from 'volta/components/bv-btn';
import type { TemplateOnlyComponent } from '@ember/component/template-only';

interface BvEmptySearchResultSignature {
  Args: {
    description?: string;
    primaryAction?: Omit<BvBtnArgs, 'text'> & { content: BvBtnArgs['text'] };
    title?: string;
  };
  Blocks: {
    action: [];
  };
  Element: HTMLElement;
}

const BvEmptySearchResultComponent = <template>
  <BvStack @align='center' @gap='3' ...attributes>
    <BvText @variant='heading-md' @as='p'>
      {{@title}}
    </BvText>
    {{#if @description}}
      <BvText @color='subdued' @as='p'>
        {{@description}}
      </BvText>
    {{/if}}
    {{#if (has-block 'action')}}
      {{yield to='action'}}
    {{else if @primaryAction}}
      <BvBtn
        @color='primary'
        @text={{@primaryAction.content}}
        @onClick={{@primaryAction.onClick}}
      />
    {{/if}}
  </BvStack>
</template> satisfies TemplateOnlyComponent<BvEmptySearchResultSignature>;

export default BvEmptySearchResultComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvEmptySearchResult: typeof BvEmptySearchResultComponent;
    'bv-empty-search-result': typeof BvEmptySearchResultComponent;
  }
}
